import { type ChangeEvent } from 'react'

import { Input, LightModePrimitiveColors } from '@enechain/ecloud-designsystem'
import { FaMagnifyingGlassRegular } from '@enechain/ecloud-icons'

import { iconSize } from '~/constants/iconSize'

type Props = {
  value: string
  onChange: (value: string) => void
  placeholder: string
  width?: string
}

// design `/admin/occto.html` の検索 input (line 61-64) を再現する。
// ecl-select--sm スタイルの input 右端に虫眼鏡 icon を absolute position で重ねる構造。
export const SearchInput = ({
  value,
  onChange,
  placeholder,
  width = '320px',
}: Props): React.ReactElement => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>): void => {
    onChange(e.target.value)
  }

  return (
    <div style={{ position: 'relative', width }}>
      {/*
        size は指定しない (= 既定 md = 40px)。 design `admin/occto.html` の検索欄は
        `.ecl-input--sm` (`css/components.css` で `height: 40px`) で、 同じ画面の
        他の Input / [[DsSelect]] も 40px。

        以前は「chakra 既定だと font-size が 12px になる」 のを避けるため
        `size="lg"` を置いていたが、 それだと `--input-height: sizes.11` = **44px** を
        引いてしまい、 検索欄だけ 4px 高い状態だった。 font-size の方は 2026-08-19 の
        commit 77a0896e3f が `~/constants/system.ts` の `input` recipe
        (`sm` / `md` に `fontSize: 'md'`) でアプリ全体を 14px に直しており、
        この回避は不要になっている (2026-08-24 デザイナー指摘 #5095)。
      */}
      <Input
        onChange={handleChange}
        placeholder={placeholder}
        style={{ width: '100%', paddingRight: '32px' }}
        type="search"
        value={value}
      />
      <FaMagnifyingGlassRegular
        boxSize={iconSize.gridInline}
        aria-hidden="true"
        style={{
          position: 'absolute',
          right: '10px',
          top: '50%',
          transform: 'translateY(-50%)',
          pointerEvents: 'none',
          color: LightModePrimitiveColors.neutral[500].value,
        }}
      />
    </div>
  )
}
